import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { INewOpenMarketProduct, INewProduct } from '../../../../interfaces/Product.interfaces';
import { getNewOpenMarketProduct } from '../../../../api/product/queries/getNewOpenMarketProduct';

export const useGetNewOpenMarketProductQuery = () => {
  return useQuery<INewOpenMarketProduct, AxiosError, INewProduct>(
    ['user-sell-tractors/new-tractor'],
    () => getNewOpenMarketProduct(),
    {
      select: (data: INewOpenMarketProduct) => {
        return {
          ...data,
          startOnSaleDate: data.approvalDate,
        };
      },
    },
  );
};
